import React from "react";
import firstdraft from "../../assets/firstdraft.jpg";
import headerImage from "../../assets/headerImage.jpg"; // Example header image
import w21 from "../../assets/w2-1.png";
import w22 from "../../assets/w2-2.png";
import w23 from "../../assets/w2-3.png";
import w24 from "../../assets/w2-4.png";
import w25 from "../../assets/w2-5.png";
import w26 from "../../assets/w2-6.png";
import w27 from "../../assets/w2-7.png";
import w28 from "../../assets/w2-8.png";
import w29 from "../../assets/w2-9.png";
import w210 from "../../assets/w2-10.png";
import w211 from "../../assets/w2-11.png";
import w212 from "../../assets/w2-12.png";
import w213 from "../../assets/w2-13.png";
import w214 from "../../assets/w2-14.png";
import w215 from "../../assets/w2-15.png";
import w216 from "../../assets/w2-16.png";
import w217 from "../../assets/w2-17.png";
import w218 from "../../assets/w2-18.jpg";
import w219 from "../../assets/w2-19.jpg";
import w220 from "../../assets/w2-20.jpg";
import w221 from "../../assets/w2-21.jpg";
import w222 from "../../assets/w2-22.jpg";
import w223 from "../../assets/w2-23.jpg";
import w224 from "../../assets/w2-24.jpg";
import w225 from "../../assets/w2-25.jpg";
import w226 from "../../assets/w2-26.jpg";
import w227 from "../../assets/w2-27.jpg";
import w228 from "../../assets/w2-28.jpg";
import w229 from "../../assets/w2-29.jpg";
import w230 from "../../assets/w2-30.png";
import w231 from "../../assets/w2-31.png";
import w232 from "../../assets/w2-32.png";
import w4_2 from "../../assets/w4_2.jpg";
import w4_3 from "../../assets/w4_3.jpg";
import w4_4 from "../../assets/w4_4.jpg";
import w4_5 from "../../assets/w4_5.jpg";
import w4_6 from "../../assets/w4_6.jpg";
import w4_7 from "../../assets/w4_7.jpg";
import w9_1 from "../../assets/w9_1.jpg";
import w9_6 from "../../assets/w9_6.jpg";


const FinalProject = () => {
  return (
    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
          <h1 className="text-4xl font-bold text-bg-secondary" >
            Final Project - Robo-Buddy
          </h1>
        </div>
      

      {/* Initial Concept */}
      <div id="concept" className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">Initial Concept</h2>
        <p className="text-justify text-gray-700">
          Inspired by R2D2 builders, the idea for this project was to create a <b>robo -  assistant </b>that follows its owner, 
          carries their belongings, and integrates with voice commands. The concept evolved into a <b>smart companion robot </b> 
          with real-time tracking and obstacle detection. As the time of the fabacademy is limited, I am going to concentrate on building a robot that follows you where you are going and carrying your belongings first and may upgrade smart features in the future.
        </p>
      </div>

      {/* First Draft */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">First Draft</h2>
        <p className="text-justify text-gray-700">
          I started with a rough sketch to visualize my project.
        </p>
        <div className="flex justify-center mt-4">
          <img
            src={firstdraft}
            alt="First Draft"
            className="rounded-lg shadow-md max-w-full h-auto"
          />
        </div>
      </div>

      {/* Basic Concept */}
      <div id="mechanics" className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">Basic Concept</h2>
        <p className="text-justify text-gray-700">
          The <b>Robo-Buddy</b> is designed to follow its user using a <b>Bluetooth, Wifi or UWB wristband</b>. 
          It relies on <b>real-time tracking</b>, sensors for navigation, and obstacle avoidance.
        </p>
      </div>

      {/* Mechanical Construction */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">Mechanical Construction</h2>
        <p className="text-justify text-gray-700">
          The robot consists of a <b>circular aluminum chassis</b> with <b>modular 3D-printed parts</b>. 
          A <b>dome and metal rods</b> provide structural stability.
        </p>
      </div>

      {/* RF Bracelet */}
      <div id="voice-control" className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">RF Bracelet</h2>
        <p className="text-justify text-gray-700">
          The RF Bracelet acts as a <b>guiding device</b>, emitting signals that the <b>Robo-Buddy</b> follows.
        </p>
      </div>

      {/* Voice Control & Connectivity */}
      <div className="mb-6">
        You can find a first draft of my project if you check out my first assignment.

      </div>
        {/* Modelling Section */}

        <h3 className="text-2xl font-bold text-center mt-8 mb-4">Modeling</h3>
        <h4 className="text-xl font-bold text-center mt-4 mb-4">2D-Modeling</h4>
        <p className="text-justify text-gray-700 mb-6">
          One way to produce the bearing blocks for the drive of my final project is to design them in 2D and cut them out with the metal laser cutter.  For this reason, I will first model the bearing blocks in Inkscape. For my final project, I need two bearing blocks, which accommodate a 13mm ball bearing and connect the two shafts to each other via a toothed belt. I therefore need a bearing block to which the stepper motor is attached and the drive shaft for the tires, as well as a counterpart that receives the drive shaft.
        </p>

        <img src={w21} alt="Description of w2-1" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">The dimensions should be 130mm x 60mm. I also need two recesses. One for the ball bearing and one for the motor shaft. </p>
<img src={w23} alt="Description of w2-3" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">After I have drawn the first circle and entered the dimensions 6.5 mm radius Rx and Ry at the top, I draw the second circle with the diameter of the drive shaft. The Nema17 stepper motor has an outer shaft diameter of 8mm.</p>
<p className="text-justify text-gray-700 mb-6">Next, I want to center the circles. To do this, I first mark all the elements. </p>
<img src={w28} alt="Description of w2-8" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, I use the align tool and select center on horizontal axis.</p>
<img src={w26} alt="Description of w2-6" className="my-4 mx-auto rounded shadow-md" />
<img src={w29} alt="Description of w2-9" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Now the holes with which the motor block is attached are still missing. The frame size of the Nema17 is 42mmx42mm. In the data sheet I found out that the distance between the screw holes is 31mm.

In addition, M3 is used for the screws. I looked in the ISO thread table DIN 13, T1 and found that the through hole for an M3 fine thread is 3.2mm. So I draw 4 holes with the corresponding dimensions. 
 </p>
<img src={w210} alt="Description of w2-10" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, I draw a circle with a diameter of 32mm around the elements for orientation.</p>
<img src={w211} alt="Description of w2-11" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">The distribution tool helps to distribute the through holes accordingly on the auxiliary circle. Next, the circle that we needed to distribute the objects is deleted. </p>
<img src={w213} alt="Description of w2-13" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">I group the elements so that they can no longer move in the future. A little hint: Unlike most programs, Inkscape uses Shift to select multiple objects. </p>
<img src={w215} alt="Description of w2-15" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6"></p>
<img src={w216} alt="Description of w2-16" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">When drawing, I noticed the error that the motor should not float in the middle of the bearing block, but must be placed at the bottom. So I move the group and save the file as .svg. </p>
<img src={w217} alt="Description of w2-17" className="my-4 mx-auto rounded shadow-md" />


<h4 className="text-xl font-bold text-center mt-4 mb-4">3D-Modeling</h4>
<p className="text-justify text-gray-700 mb-6"> Next, I modeled the second bearing block in Fusion 360 3D. This has the advantage that I can simply print it out for testing and don't have to use so much aluminum for the first prototypes. 
I start by creating a sketch in Fusion and create a square measuring 600 mm x 700 mm.</p>

<img src={w218} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, I press Finish Sketch to finish the sketch.  </p>
<img src={w219} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6"> Then I extrude the cuboid. </p>
<img src={w220} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">The next step is to model the drill holes in the lower part of the block. To do this, I switch back to the sketch view, select the underside of the block as the basis and draw a guide line in the middle. I create a circle and would now like to have it on both sides of the block, which is why I mirror it on the auxiliary line. </p>
<img src={w221} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">After removing the auxiliary line, it looks like this. </p>
<img src={w222} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Then I finish the sketch again and cut out the drill holes with the Extrude tool at a depth of 15mm. </p>
<img src={w223} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">The model then looks like this:  </p>
<img src={w224} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Next, we take care of the recess for the ball bearing. Since the ball bearing only has a depth of 5mm and we have a material thickness of 10mm, we have to draw a circle with 13mm and drill 5mm deep.  </p>
<img src={w225} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">We want to leave a margin of 2mm. To do this, we select the same center point and draw a circle with a diameter of 11mm, which we then drill through to the full thickness of the material.  </p>
<img src={w226} className="my-4 mx-auto rounded shadow-md" />
<img src={w227} className="my-4 mx-auto rounded shadow-md" />
<img src={w228} className="my-4 mx-auto rounded shadow-md" />
<img src={w229} className="my-4 mx-auto rounded shadow-md" />

<img src={w230} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">Our model for the bearing block is finished.  </p>


<h4 className="text-xl font-bold text-center mt-4 mb-4">3D modeling of the final project</h4>
<p className="text-justify text-gray-700 mb-6">The two parts of the final project shown here are only small components. At the same time, I tried to construct the robot in Fusion 360 for the first time.  </p>
<img src={w231} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">I started with the construction of the base plate, in which I made two cut-outs for the wheels and four screw holes for attaching a 360-degree rotating wheel. I positioned 8 slots on the edge into which the 3D printed cover will later be inserted. I also added 4 threaded rods to connect the two plates together.
</p>
<img src={w232} className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">A second plate with the same slots and holes for the threaded rods was then placed on the threaded rods. 
The dome was then mounted on top of this and a compartment inserted. </p>



<h3 className="text-2xl font-bold text-left mb-6">Distance Measuring with ESP32</h3>
        <p className="text-justify text-gray-700 mb-6">I chose the ESP32 for my project because of its built-in connectivity features and its simplicity to program. In addition it has many pins for connecting different sensors and devices and supports multiple energy-saving power modes.</p>
        <p className="text-justify text-gray-700 mb-6">Since I will need two ultrasonic sensors in my final project for obstacle avoidance I simulated the usage in week 4 of the fabacademy.</p>


        {/* Simulation Section*/}

        <h2 className="text-3xl font-bold text-left mb-6">Simulation of a Microcontroller</h2>
        <p className="text-justify text-gray-700 mb-6">I used wokwi.com to simulate the operation of a microcontroller.</p>

        <img src={w4_2} alt="Wokwi" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">Wokwi is an easy-to-use online tool that provides simulations for four different development boards and their simulation on their homepage.

As I want to use the ESP32 in my final project, I decided to use that microcontroller this week too.

I selected the "Starter Template" of the basic ESP32 and by pressing the play button, I compiled the "hello world" - script.</p>


<img src={w4_3} alt="Wokwi" className="my-4 mx-auto rounded shadow-md" />



        <p className="text-justify text-gray-700 mb-6">Next I wanted to simulate the operation of two ultrasonic sensors.</p>

        <img src={w4_4} alt="Ultrasonic Sensor" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">By clicking the "+" button, you can add components to your simulation. I added two ultrasonic sensors and wired them to the ESP32.</p>
        
        <img src={w4_5} alt="Circuit" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">The next step was to write a program. I did a little research and found out that the ultrasonic sensor calculates the distance by using the duration the sound needs to be reflected by the object and returning to the sensor. Thus, the formula to calculate the distance is: (duration × sound speed) / 2.</p>
        <p className="text-justify text-gray-700 mb-6">At the beginning of my program I defined the values for SOUND_SPEED, TIMEOUT and the trigger and echo pins of the sensors</p>
        <p className="text-justify text-gray-700 mb-6">Then, in the void setup(), I set the baud rate to 115200. The Baud rate represents the number of signal changes or symbols transmitted per second. If you select the wrong Baud Rate, your computer will not be able to understand the transmission as it doesn't know where a symbol ends. Therefore it is important for the serial communication with your computer.</p>
        <p className="text-justify text-gray-700 mb-6">Finally, I set the pinMode() of the used pins to OUTPUT for the trigger pins and INPUT for the echo pins.
        </p>
        <p className="text-justify text-gray-700 mb-6">That's it for the setup.</p>
        <p className="text-justify text-gray-700 mb-6">In the loop, I measured the duration of the left and right sensors and calculated the distance. Finally, I printed the results to the simulated computer via Serial.print().</p>
        
        <img src={w4_6} alt="Loop" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">By clicking on the sensors, you can change the measured distance.</p>

        
        <img src={w4_7} alt="Editing Sensors" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">At the bottom of the picture, you can see the measured distances.</p>


        <h2 className="text-3xl font-bold text-left mb-6">Obstacle Avoidance – First Prototype</h2>



<p className="text-justify text-gray-700 mb-6">
  As part of my final project – I need a way to detect obstacles and maintain a safe distance to users or surroundings. For that purpose, I plan to integrate <strong>two HC-SR04 ultrasonic distance sensors</strong> into the robot system.
</p>

<p className="text-justify text-gray-700 mb-6">
  During <a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/week09/" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Week 9 (Input Devices)</a>, I designed and milled a custom PCB that acts as a prototype for the sensor interface of my robot. The board is based on the <strong>Seeed Studio XIAO ESP32S3</strong> and includes <strong>two dedicated pin headers</strong> for connecting ultrasonic sensors (VCC, TRIG, ECHO, GND), as well as a separate <strong>I2C header</strong> for communication with the main control board.
</p>

<p className="text-justify text-gray-700 mb-6">
  While testing the setup, I realized that the sensors require a <strong>5V supply</strong>, which was not ideal for my 3.3V-optimized board. Fortunately, I had added a 5V fallback header. This important insight will influence the next revision of the sensor board for the final robot, where I will route 5V power directly to the sensor headers and finalize the communication interface between boards.
</p>

<img src={w9_1} alt="PCB with ultrasonic pin headers" className="my-4 mx-auto rounded shadow-md" />
<img src={w9_6} alt="Sensor attached to prototype board" className="my-4 mx-auto rounded shadow-md" />

<p className="text-justify text-gray-700 mb-6">
Building and testing this prototype in Week 9 was a really important step for my robot project – it helped me figure out how to connect the sensors properly, get reliable measurements, and prepare everything for future I2C communication between the boards.</p>

</div>


  );
};

export default FinalProject;
